module.exports = __webpack_public_path__ + "img/230.general_arrangement.f20619cc.svg";